"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.writeToPath = exports.writeToString = exports.writeToBuffer = exports.writeToStream = exports.write = exports.format = exports.FormatterOptions = exports.CsvFormatterStream = void 0;
const util_1 = require("util");
const stream_1 = require("stream");
const fs = __importStar(require("fs"));
const FormatterOptions_1 = require("./FormatterOptions");
const CsvFormatterStream_1 = require("./CsvFormatterStream");
__exportStar(require("./types"), exports);
var CsvFormatterStream_2 = require("./CsvFormatterStream");
Object.defineProperty(exports, "CsvFormatterStream", {
  enumerable: true,
  get: function () {
    return CsvFormatterStream_2.CsvFormatterStream;
  }
});
var FormatterOptions_2 = require("./FormatterOptions");
Object.defineProperty(exports, "FormatterOptions", {
  enumerable: true,
  get: function () {
    return FormatterOptions_2.FormatterOptions;
  }
});
const format = options => {
  return new CsvFormatterStream_1.CsvFormatterStream(new FormatterOptions_1.FormatterOptions(options));
};
exports.format = format;
const write = (rows, options) => {
  const csvStream = (0, exports.format)(options);
  const promiseWrite = (0, util_1.promisify)((row, cb) => {
    csvStream.write(row, undefined, cb);
  });
  rows.reduce((prev, row) => {
    return prev.then(() => {
      return promiseWrite(row);
    });
  }, Promise.resolve()).then(() => {
    csvStream.end();
  }).catch(err => {
    csvStream.emit('error', err);
  });
  return csvStream;
};
exports.write = write;
const writeToStream = (ws, rows, options) => {
  return (0, exports.write)(rows, options).pipe(ws);
};
exports.writeToStream = writeToStream;
const writeToBuffer = function (rows) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const buffers = [];
  const ws = new stream_1.Writable({
    write(data, enc, writeCb) {
      buffers.push(data);
      writeCb();
    }
  });
  return new Promise((res, rej) => {
    ws.on('error', rej).on('finish', () => {
      return res(Buffer.concat(buffers));
    });
    (0, exports.write)(rows, opts).pipe(ws);
  });
};
exports.writeToBuffer = writeToBuffer;
const writeToString = (rows, options) => {
  return (0, exports.writeToBuffer)(rows, options).then(buffer => {
    return buffer.toString();
  });
};
exports.writeToString = writeToString;
const writeToPath = (path, rows, options) => {
  const stream = fs.createWriteStream(path, {
    encoding: 'utf8'
  });
  return (0, exports.write)(rows, options).pipe(stream);
};
exports.writeToPath = writeToPath;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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